export enum Page {
    LOGIN = "/",
    EASY_LOGIN="/easy",
    AGREEMENT="/agreement",
		// TODO 干吗的
    //REFRESH_LOGIN = "/refresh_login",
    //WX_AUTO_LOGIN = "/wx_auto_login",
    LOGOUT = "/logout",
    RETRIEVE_PASSWORD = "/retrieve_passowrd",
    REGISTER = "/register",
    REGISTER_PAST = "/past/register",
    EASY_REGISTER = "/easy_register",
//    REGISTER_STAFF = "/register_staff",
//    AGREEMENT = "/agreement",
    AUTH_CODE_TOKEN = "/access_token",
    AUTH_CODE_LOGIN = "/access_token_login",
    REGISTER_SUCCESS = "/register_success",
    // ACCOUNT_CENTER_NAV = "/account_center_nav",
    ACCOUNT_CENTER = "/account_center",
    ACCOUNT_INFO = "/account_info",
    RESET_MOBILE = "/reset_mobile",
    RESET_MOBILE_APEAL = "/appeal",
    RESET_PWD = "/reset_pwd",
    STAFF_LIST = "/staff_list",
    STAFF_LIST_EDIT_STAFF = "/staff/edit",
    PRODUCT_MAP = "/product_map",
    // ACCOUNT_CENTER_ERROR_PAGE = "/account_center_error",
    SECURITY_CENTER = "/security_center",
    // SECURITY_CENTER_RISKLIST = "/security_center/risklist",
    SECURITY_CENTER_LOGINLOG = "/security_center/log",
    // SECURITY_CENTER_RISKIPOPERATION = "/security_center/riskipoperation",
    SECURITY_FORCE_OFFLINE = "/security_center/force_offline",
    // SECURITY_THIRDPART_AUTHORIZATION = "/security_center/thirdpart_authorization",
    // SECURITY_THIRDPART_BIND = "/security_center/thirdpart_bindinfo",

   SUPPORT_LOGIN = "/support/login",
   SUPPORT_REGISTER = "/support/register",
//    SUPPORT_REGISTER_SUCCESS = "/support/register_success",
   SUPPORT_RETRIEVE_PASSWORD = "/support/retrieve_passowrd",
  }